import { render, staticRenderFns } from "./AppointmentTypeCreate.vue?vue&type=template&id=04cd1215"
import script from "./AppointmentTypeCreate.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports